import { motion } from "framer-motion";

const fadeUp = {
  hidden: { opacity: 0, y: 30 },
  visible: (i) => ({ opacity: 1, y: 0, transition: { delay: i * 0.1, duration: 0.6, ease: "easeOut" } }),
};

export default function TermsPage() {
  return (
    <div data-testid="terms-page" className="pt-20">
      <section className="py-24 md:py-32 bg-luxury-black">
        <div className="max-w-4xl mx-auto px-6 md:px-12">
          <motion.div initial="hidden" animate="visible">
            <motion.p variants={fadeUp} custom={0} className="text-xs font-body font-medium uppercase tracking-[0.3em] text-gold mb-6">Legal</motion.p>
            <motion.h1 variants={fadeUp} custom={1} className="font-heading text-5xl sm:text-6xl font-light text-white leading-none mb-12">Terms & Conditions</motion.h1>

            <motion.div variants={fadeUp} custom={2} className="space-y-10 text-white/60 font-body font-light text-sm leading-relaxed">
              <div>
                <h2 className="text-white font-heading text-2xl mb-4">Service Agreement</h2>
                <p>By engaging Aristocrats JA Signature Events, you agree to these terms. Our services are provided on a reservation basis and are subject to availability. A signed contract and deposit are required to secure your booking.</p>
              </div>
              <div>
                <h2 className="text-white font-heading text-2xl mb-4">Booking & Deposits</h2>
                <p>A non-refundable deposit of 30% is required to secure your event date. The remaining balance is due 14 days prior to the event. Late payments may result in service modifications or cancellation.</p>
              </div>
              <div>
                <h2 className="text-white font-heading text-2xl mb-4">Cancellation Policy</h2>
                <p>Cancellations made 30+ days before the event: deposit is retained as a credit for future booking. Cancellations made within 30 days: deposit is non-refundable. Cancellations within 7 days: full payment is required.</p>
              </div>
              <div>
                <h2 className="text-white font-heading text-2xl mb-4">Intellectual Property</h2>
                <p>All photographs, videos, and media produced by Aristocrats JA remain our intellectual property. Clients receive a usage license upon full payment. Commercial use requires separate licensing arrangements.</p>
              </div>
              <div>
                <h2 className="text-white font-heading text-2xl mb-4">Delivery Timeline</h2>
                <p>Edited photographs: 2-4 weeks post-event. Cinematic videos: 4-8 weeks post-event. Same-day social media content available with VIP packages. Rush delivery available at additional cost.</p>
              </div>
              <div>
                <h2 className="text-white font-heading text-2xl mb-4">Drone Operations</h2>
                <p>Drone coverage is subject to weather conditions, venue restrictions, and aviation regulations. Aristocrats JA reserves the right to modify or cancel drone services when safety conditions require. Alternative ground-based coverage will be provided.</p>
              </div>
              <div>
                <h2 className="text-white font-heading text-2xl mb-4">Liability</h2>
                <p>Aristocrats JA carries comprehensive professional liability and equipment insurance. Our liability for any claim shall not exceed the total service fee paid. We are not liable for circumstances beyond our reasonable control.</p>
              </div>
              <div>
                <p className="text-white/30 text-xs">Last updated: February 2026</p>
              </div>
            </motion.div>
          </motion.div>
        </div>
      </section>
    </div>
  );
}
